import React, { useState, useEffect } from 'react';
import config from "../../Config";
import axios from "axios";



function SessionsDropDown(props) {

    const [AccessKey, setAccessKey] = useState(localStorage.getItem("AccessKey"));
    const [UserID, setUserID] = useState(localStorage.getItem("ID"));
    const [MemberType, setMemberType] = useState(localStorage.getItem("MemberType"));
    const [sessions, setSessions] = useState([]);


    useEffect(() => {
      
        const dashboardParms = {
            AccessKey: AccessKey,
            UserID: UserID,
            MemberType: MemberType || "Admin",
            pageNo: 1,
            pageSize: 1000,
            SchoolID: 1
        };

        var api_config = {
            method: 'post',
            url: config.base_url + 'AcademicSession/GetAcademicSessions',
            headers: {
                'Content-Type': 'application/json'
            },
            data: dashboardParms
        };

        axios(api_config)
            .then(function (response) {
                if (response.data && response.data.status_code == 1) {
                    setSessions(response.data.ListofRecords || []);
                } else {
                    setSessions([]);
                }
            })
            .catch(function (error) {
                setSessions([]);
                //console.log(error);
            });

    }, []);

    

    return (
        sessions.map((item, index) => {
            return (
                <option value={item.Session_ID} key={index}>{item.Session_Name}</option>
            )
        })
    );
}

export default SessionsDropDown;